// tiny fetch wrapper — always sends the session cookie, throws on {ok:false}
const j = async (url, opts = {}) => {
  let res
  try {
    res = await fetch(url, {
      credentials: 'include',
      headers: {'Content-Type': 'application/json'},
      ...opts,
    })
  } catch (netErr) {
    // network-layer reject (Safari shows "Load failed") — never reached the server or got no response
    console.error('[api] network fail', (opts.method || 'GET'), url, netErr && netErr.message)
    throw netErr
  }
  const data = await res.json().catch(() => ({ok: false, error: 'bad json'}))
  if (!res.ok || data.ok === false) {
    const err = new Error(data.error || 'HTTP ' + res.status)
    err.status = res.status
    err.code = data.code
    throw err
  }
  return data
}

export const api = {
  // auth
  me: () => j('/api/me'),
  signup: (username, password) => j('/api/signup', {method: 'POST', body: JSON.stringify({username, password})}),
  login: (username, password) => j('/api/login', {method: 'POST', body: JSON.stringify({username, password})}),
  logout: () => j('/api/logout', {method: 'POST'}),

  // profile
  saveProfile: (name, goal) => j('/api/profile', {method: 'POST', body: JSON.stringify({name, goal})}),

  // days + entries
  day: date => j('/api/day?date=' + encodeURIComponent(date)),
  analyze: image => j('/api/analyze', {method: 'POST', body: JSON.stringify({image})}),
  addEntry: entry => j('/api/entry', {method: 'POST', body: JSON.stringify(entry)}),
  editEntry: (eid, patch) => j('/api/entry/' + eid, {method: 'PATCH', body: JSON.stringify(patch)}),
  delEntry: eid => j('/api/entry/' + eid, {method: 'DELETE'}),

  // food library + history
  foods: q => j('/api/foods' + (q ? '?q=' + encodeURIComponent(q) : '')),
  delFood: fid => j('/api/food/' + fid, {method: 'DELETE'}),
  history: (days = 30) => j('/api/history?days=' + days),
}
